<template>
  <Layout>
    <div class="top" :style="{height: fullHeight+'px',textAlign:'center'}">
      <div :style="{marginTop: fullHeight/4+'px'}">
<!--      <p style="font-size: 30px;color: #704aff;font-family:宋体;font-weight:bold">PSD,  PNG, JPG</p>-->
      <p style="font-size: 30px;color: #535353;margin-top: 20px;font-weight: bold">网站提供精美优雅的设计素材</p>
      <Input search v-model="searchVal" suffix="ios-search" placeholder="搜索免费图片" style="width: 23%;box-shadow: 0 0 5px #888888;margin-top: 20px" @on-search="search(1)" />
      <p/>
      <ul style="display:inline-block;margin-top: 40px;font-size: 15px;font-family: 微软雅黑; width: 45%;min-width:800px;">
        <li style="" v-for="(i,index) in typeData">
          <div :style="typeStyle" @click="typeClick(index,i.id)" :class ="isActive === index ? 'addClass' : '' " >{{i.name}}</div>
        </li>
      </ul>
    </div>
    </div>
    <Content style="">
      <div style="font-size: 20px;font-family:微软雅黑;text-align:left;margin: 20px 8%;font-weight: bold">免费素材图片</div>
<!--      <Spin size="large" style="margin-left: 50%;margin-top: 200px;" v-if="loading" fix></Spin>-->
      <div style="width: 85%;margin: auto">
      <img v-for="(i,index) in imagesData" v-lazy="i.url" :key="i.id" width="300px" style="margin: 10px" @click="clickImage(i.id)">
      </div>
    </Content>
    <Footer style="text-align: center">
      <Page ref="pages" :total=total :page-size="30" @on-change="pageClick"/>
    </Footer>
  </Layout>
</template>

<script>
  import {ajaxFetch} from '../utils'
  export default {
    name: 'MainPage',
    computed: {
      fullHeight: function () {
        // return  window.innerWidth*0.20625
        return 400
      }
    },
    data () {
      return {
        searchVal: '',
        typeId: 0,
        total: 0,
        loading: false,
        isActive:false,
        isSearch: false,
        typeStyle: {
          marginTop : '20px',
          height:'32px',
          display: 'inline-block',
          fontWeight: 'bold'
        },
        typeData:[],
        imagesData:[]
      }
    },
    mounted: function () {
      this.getTypeData()
    },
    methods: {
      getTypeData: function () {
         ajaxFetch('post','/client/paperCategory/list',{type: 1},(response) => {
          if (response.code === 200) {
            this.typeData = response.data
            this.typeClick(0, this.typeData[0].id)
          } else {

          }
        }, (err) => {
          console.log(err)
        } )
      },
      listByCategory: function (id, current) {
        ajaxFetch('post','/client/productTable/listByCategory',{categoryId:id,current:current,size:30},(response) => {
          if (response.code === 200) {
            this.imagesData = response.data.data
            this.loading = false
            this.total = parseInt(response.data.total)
          } else {

          }
        }, (err) => {
          console.log(err)
        } )
      },
      typeClick: function(index, id) {
        this.isSearch = false
        this.typeId = id
        this.loading = true
        this.isActive = index
        this.listByCategory(id, 1)
        this.$refs['pages'].currentPage = 1
      },
      pageClick: function(page) {
        this.loading = true
        window.scrollTo(0,0);
        if(this.isSearch){
          this.search(page)
        }else {
          this.listByCategory(this.typeId,page)
        }
      },
      clickImage: function (id) {
        this.$router.push({name: 'detailImgPage', query: {id: id}})
      },
      search: function (current) {
        if (current === 1 ){
          this.$refs['pages'].currentPage = 1
        }
        this.isSearch = true
        ajaxFetch('post','/client/productTable/searchByName',{type: 4, name: this.searchVal, current:current, size:30},(response) => {
          if (response.code === 200) {
            this.imagesData = response.data.data
            this.total = parseInt(response.data.total)
          } else {
          }
        }, (err) => {
          console.log(err)
        } )
      },
    }
  }
</script>

<style scoped>
.top {
  background:url('../assets/first.png');
  width:100%;
  background-size: cover;
}
  li {
    display: inline;
    list-style: none;
    margin-left: 10px;
    margin-right: 10px;
    /*text-align:center;*/
  }
.addClass {
  color: #704aff;
  border-bottom: 2px solid #704aff;
}
</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue